import React, { useContext } from 'react'
import Layout from 'Components/Layout'
import blogPostService from 'Services/blogPostService'
import PropTypes from 'prop-types'
import BlogPostViewer from 'Components/BlogPostViewer'
import PageHead from 'Components/PageHead'
import TextWithBackButton from 'Components/TextWithBackButton'
import InitialPropsHelper from 'Utils/InitialPropsHelper'
import GetSchoolUrl from 'Utils/GetSchoolUrl'
import GlobalsContext from 'Contexts/GlobalsContext'
import Router from 'next/router'

const PostPage = ({ post }) => {
  const { school } = useContext(GlobalsContext)
  // todo: school is initially null, move globals context to layout where
  // globals are first fetched
  return (
    <div className="py-4 px-4 sm:px-6 md:px-12">
      <PageHead
        title={post.title}
        card={{
          title: post.title,
          type: 'article',
          url: `${GetSchoolUrl(school, `/post/${post.slug}`, true)}`,
          // use exact=true in GetSchoolUrl
          image: post.thumbnail,
        }}
      />
      <TextWithBackButton
        backButtonVisible
        backClicked={() => Router.push('/posts')}
        text="Back"
      />
      <BlogPostViewer post={post} />
    </div>
  )
}

PostPage.getInitialProps = ({ query }) => {
  const postSlug = query.slug
  return InitialPropsHelper({
    post: blogPostService.getPublicDetail(postSlug).then((data) => data.result),
  })
}

PostPage.propTypes = {
  post: PropTypes.object.isRequired,
}

export default Layout(PostPage, {
  sidebarVariant: 'HOME',
  isFooterPresent: true,
})
